var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 13,
    viewBox: "0 0 23 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12.3333C11.1203 12.3341 10.7523 12.1951 10.46 11.9404L0.70996 3.39875C0.378108 3.10878 0.169418 2.6921 0.129801 2.24037C0.0901839 1.78864 0.222885 1.33887 0.49871 0.990002C0.774535 0.641132 1.17089 0.421741 1.60058 0.380093C2.03028 0.338444 2.45811 0.477949 2.78996 0.767919L11.5 8.42125L20.21 1.04125C20.3762 0.899349 20.5674 0.793378 20.7727 0.729432C20.978 0.665487 21.1933 0.644826 21.4063 0.668639C21.6192 0.692452 21.8255 0.760267 22.0134 0.868189C22.2013 0.976111 22.3671 1.12201 22.5012 1.2975C22.65 1.47316 22.7627 1.67923 22.8323 1.9028C22.9018 2.12638 22.9267 2.36264 22.9053 2.59679C22.884 2.83094 22.8168 3.05793 22.7082 3.26354C22.5995 3.46915 22.4516 3.64895 22.2737 3.79167L12.5237 12.0429C12.2229 12.2573 11.8625 12.3596 11.5 12.3333Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4cbfbf6d32a928e9d9067166dbf8ba1e.svg";
export { ForwardRef as ReactComponent };